var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 3,
    fill: "#052038"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.81 7.84003L11.81 17.34C11.7303 17.4487 11.6295 17.5401 11.5136 17.6087C11.3977 17.6774 11.2691 17.722 11.1355 17.7397C11.0019 17.7575 10.8662 17.748 10.7364 17.712C10.6065 17.676 10.4853 17.6141 10.38 17.53L5.38002 13.53C5.25224 13.4592 5.14152 13.3613 5.05565 13.2431C4.96978 13.125 4.91084 12.9894 4.88298 12.846C4.85512 12.7026 4.85901 12.5549 4.89439 12.4131C4.92976 12.2714 4.99576 12.1391 5.08773 12.0257C5.17971 11.9122 5.29543 11.8202 5.42676 11.7563C5.55809 11.6923 5.70184 11.6579 5.8479 11.6554C5.99396 11.653 6.13878 11.6826 6.27217 11.7421C6.40557 11.8016 6.5243 11.8897 6.62002 12L10.81 15.35L17.19 6.69003C17.2675 6.58366 17.3652 6.49359 17.4775 6.42497C17.5898 6.35635 17.7145 6.31051 17.8445 6.29008C17.9745 6.26965 18.1072 6.27503 18.2351 6.30591C18.3631 6.33678 18.4837 6.39255 18.59 6.47003C18.6964 6.54751 18.7865 6.64519 18.8551 6.75747C18.9237 6.86976 18.9695 6.99447 18.99 7.12447C19.0104 7.25447 19.005 7.38722 18.9741 7.51515C18.9433 7.64307 18.8875 7.76366 18.81 7.87003V7.84003Z",
    fill: "#F3F4F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.9f2f0c13e3d188d56131ef66bb9f1b53.svg";
export { ForwardRef as ReactComponent };